import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroyTestimonials } from "../../api/apiTestimonials";
import parseError from "../../utils/parseError";

export function useDeleteAllTestimonials() {
    const queryClient = useQueryClient();

    const { mutate: deleteAllItemsMutate, isPending } = useMutation({
        mutationFn: massDestroyTestimonials,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["testimonials"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete testimonials");
        },
    });

    return { deleteAllItemsMutate, isPending };
}
